export const PARKS_CONFIG = [
  { id: 'dae968d5-630d-4719-8b06-3d107e944401', name: 'Disneyland Park', color: 'pink' },
  { id: 'ca888437-ebb4-4d50-aed2-d227f7096968', name: 'Walt Disney Studios', color: 'blue' },
];

export function normalizeName(name) {
  return name
    .toLowerCase()
    .replace(/[™®©]/g, '')
    .replace(/\s*\(.*?\)\s*/g, ' ')
    .replace(/[^a-z0-9\u00e0\u00e2\u00e4\u00e9\u00e8\u00ea\u00eb\u00ef\u00ee\u00f4\u00f9\u00fb\u00fc\u00ff\u00e7\u0153\u00e6\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function buildLookup(data) {
  const lookup = {};
  PARKS_CONFIG.forEach(park => {
    if (data[park.id]?.liveData) {
      data[park.id].liveData.forEach(entity => {
        if (entity.entityType === 'ATTRACTION') {
          lookup[normalizeName(entity.name)] = entity;
        }
      });
    }
  });
  return lookup;
}
